/**
 * Created by renlikang on 2017/5/24.
 */
import {CALL_API} from '../../middleware/api';

export const ROLE_DEL_REQUEST = 'ROLE_DEL_REQUEST';
export const ROLE_DEL_SUCCESS = 'ROLE_DEL_SUCCESS';
export const ROLE_DEL_FAILURE = 'ROLE_DEL_FAILURE';


function delRole(roleId) {
    return {
        [CALL_API]: {
            types: [ROLE_DEL_REQUEST, ROLE_DEL_SUCCESS, ROLE_DEL_FAILURE],
            endpoint: 'organization/role/delete?role_id=' + roleId,
        }
    };
}

export default (roleId) => {
    return (dispatch) => {
        return dispatch(delRole(roleId));
    };
};


// WEBPACK FOOTER //
// ./src/action/role/del.js